import { Dialog, IconButton, Alert } from '@mui/material';
import { MovementReconciliationActions } from '../bancos/MovementReconciliationActions';
import CloseIcon from '@mui/icons-material/Close';

import { PaymentsForm } from './PaymentsForm';

export const PaymentsModal = ({ initialPay, title, openModal, setModal, checkInitialData, initGetAllPayByGasto, dataCompra }) => {

    return (
        <Dialog
            className='dialogoCrearPagos'
            open={openModal}
            onClose={() => setModal(false)}
            aria-labelledby="simple-dialog-title"
        >
            <div className='ContainerDialogs'>
                <h1 className='TitleModalPresupuesto'>
                    {title}
                    <IconButton
                        style={{ padding: '0', float: 'right' }}
                        aria-label="close"
                        onClick={() => setModal(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </h1>

                {initialPay.reconciled ? <>
                    <Alert severity="info">Este pago está conciliado. Deshaz primero su conciliación para editarlo o eliminarlo.</Alert>
                    <MovementReconciliationActions movement={initialPay} type="egreso" onChanged={async()=>{if(typeof checkInitialData==='function')await checkInitialData(initialPay.id_compra);if(typeof initGetAllPayByGasto==='function')await initGetAllPayByGasto(initialPay.id_compra);setModal(false);}}/>
                </> : <PaymentsForm
                    setModal={setModal}
                    initialPay={initialPay}
                    checkInitialData={checkInitialData}
                    initGetAllPayByGasto={initGetAllPayByGasto}
                    dataCompra={dataCompra}
                />}

            </div>
        </Dialog>
    )
}
